export const superCategoryKeys = {
  all: ["super-categories"] as const,
  // Takes an optional params object so a paginated call (the default page-one
  // response) and a `{ paginate: false }` call (the full collection) land in
  // separate cache entries instead of colliding and serving each other's data.
  lists: (params?: Record<string, unknown>) =>
    [...superCategoryKeys.all, "list", params ?? {}] as const,
  list: (params?: Record<string, unknown>) =>
    [...superCategoryKeys.lists(), params] as const,
  details: () => [...superCategoryKeys.all, "detail"] as const,
  detail: (id: string) => [...superCategoryKeys.details(), id] as const,
  tree: (id: string) => [...superCategoryKeys.all, "tree", id] as const,
};
